import { shouldCreateSpan } from './utils';
import Span from '../span';
var eventPairs = [['redirectStart', 'redirectEnd', 'Redirect'], ['domainLookupStart', 'domainLookupEnd', 'Domain lookup'], ['connectStart', 'connectEnd', 'Making a connection to the server'], ['requestStart', 'responseEnd', 'Requesting and receiving the document'], ['domLoading', 'domInteractive', 'Parsing the document, executing sync. scripts'], ['domContentLoadedEventStart', 'domContentLoadedEventEnd', 'Fire "DOMContentLoaded" event'], ['loadEventStart', 'loadEventEnd', 'Fire "load" event']];
function createNavigationTimingSpans(timings, baseTime, trStart, trEnd) {
  var spans = [];
  for (var i = 0; i < eventPairs.length; i++) {
    var start = timings[eventPairs[i][0]];
    var end = timings[eventPairs[i][1]];
    if (!shouldCreateSpan(start, end, trStart, trEnd, baseTime)) {
      continue;
    }
    var span = new Span(eventPairs[i][2], 'hard-navigation.browser-timing');
    var data = null;
    if (eventPairs[i][0] === 'requestStart') {
      span.pageResponse = true;
      data = {
        url: location.origin
      };
    }
    span._start = start - baseTime;
    span.end(end - baseTime, data);
    spans.push(span);
  }
  return spans;
}
export { createNavigationTimingSpans };